export const baseline = "8px";
export const x = (a: string, b: number) => {
  return `${parseFloat(a.match(/\d+/)?.[0] ?? "") * b}px`;
};
